import { react2angular } from 'react2angular';
import { AlarmRuleViewModal } from './AlarmRuleViewModal';

angular.module('webtip.module')
  .component('alarmRuleViewModal', react2angular(AlarmRuleViewModal, ['rule', 'onClose'], [
    'alarmRuleService',
    'accountService',
    'alarmNotificationService',
    'formatTimestampFilter',
    '$translate',
  ]))
  .component('alarmRuleViewDialog', {
    bindings: { resolve: '<', dismiss: '&' },
    template: '<alarm-rule-view-modal rule="$ctrl.resolve.rule" on-close="$ctrl.dismiss"></alarm-rule-view-modal>',
  });